import { FormControl, Stack, InputLabel, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { FC } from 'react';

export type DataImportInfoFormValues = {
	name: string;
	description: string;
};

export type DataImportInfoFormProps = {
	form: ReturnType<typeof useFormik<DataImportInfoFormValues>>;
};

export const DataImportInfoForm: FC<DataImportInfoFormProps> = ({ form }) => {
	return (
		<Stack spacing={3}>
			<FormControl>
				<InputLabel>Name</InputLabel>
				<TextField
					{...form.getFieldProps('name')}
					error={!!form.errors.name}
					helperText={form.errors.name}
				/>
			</FormControl>
			<FormControl fullWidth>
				<InputLabel>Description</InputLabel>
				<TextField
					minRows={3}
					multiline
					{...form.getFieldProps('description')}
					error={!!form.errors.description}
					helperText={form.errors.description}
				/>
			</FormControl>
		</Stack>
	);
};
